import script from "./reportDefer.vue?vue&type=script&setup=true&lang=js"
export * from "./reportDefer.vue?vue&type=script&setup=true&lang=js"

import "./reportDefer.vue?vue&type=style&index=0&id=622a5ac8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622a5ac8"]])

export default __exports__